<div class="thumb-for-wizzard-product">
    <div class="thumb-for-wizzard-product__inner">
        <shared-loader-for-placeholder *ngIf="loading || (!imgLoaded && src)" class="thumb-for-wizzard-product__loader">
        </shared-loader-for-placeholder>

        <ng-container *ngIf="src && !loading">
            <div class="thumb-for-wizzard-product__holder" [hidden]="!imgLoaded"
                [ngStyle]="{'background-color': bgColor}">
                <img directive-image-preload [url]="src" [width]="width" [height]="height" (onLoaded)="onLoaded($event)"
                    class="thumb-for-wizzard-product__img" [ngClass]="{'is-icon': isIcon}" [alt]="title" />
            </div>
        </ng-container>

        <ng-container *ngIf="!src && !loading && title">
            <div class="thumb-for-wizzard-product__fallback" [ngStyle]="{'background-color': bgColor || null}">
                <div class="thumb-for-wizzard-product__fallback-label">
                    {{title | wordsFirstLetter:1}}
                </div>
            </div>
        </ng-container>

    </div>
</div>